import React, { useState, useEffect } from 'react';
import moment from 'moment';

import './style.scss'

const Countdown = ({ countdownTimer }) => {

  return (
    <div className="countdown">
      <div className="card">
        <div className="countdown-value">{countdownTimer.days}</div>
        <div className="countdown-unit">Days</div>
      </div>
      <div className="card">
        <div className="countdown-value">{countdownTimer.hours}</div>
        <div className="countdown-unit">Hours</div>
      </div>
      <div className="card">
        <div className="countdown-value">{countdownTimer.mins}</div>
        <div className="countdown-unit">Mins</div>
      </div>
      <div className="card">
        <div className="countdown-value">{countdownTimer.secs}</div>
        <div className="countdown-unit">Secs</div>
      </div>
    </div>
  );
}

const InfoMessage = ({ messageText }) => {
  return <p className="message info-message"><span className="fa fa-info-circle fa-lg fa-fw" aria-hidden="true"></span> {messageText}</p>;
}
const LoadingSpinner = () => {
  return <div className="loading-spinner" aria-label="Loading..."></div>;
}

export const DateFlipDown = ({ periodend }) => {

  const [countdownTimer, setCountdownTimer] = useState(null);
  const [countdownInfoMessage, setCountdownInfoMessage] = useState('');

  useEffect(() => {
    const init = () => {      
      const unixEndDate = Number(moment(`${periodend} ${'00:00'} ${'am'}`, 'YYYY-MM-DD hh:mm A').format('X'))
    
      if (unixEndDate && !countdownTimer) {
        setInterval(() => playTimer(unixEndDate), 1000);
      }
    }
    init()
  }, [periodend])


  function playTimer(currentUnixEndDate) {
    const distance = currentUnixEndDate - moment().format('X');

    if (distance > 0) {
      setCountdownTimer({
        days: parseInt(distance / (60 * 60 * 24), 10),
        hours: parseInt(distance % (60 * 60 * 24) / (60 * 60), 10),
        mins: parseInt(distance % (60 * 60) / (60), 10),
        secs: parseInt(distance % 60, 10)
      });
      setCountdownInfoMessage('');
    }
    else {
      setCountdownInfoMessage('Countdown ended.');
      setCountdownTimer(null);
    }
  }

  return (
    <>
      <main>
        {periodend && !countdownTimer ?
          <LoadingSpinner /> : countdownTimer ?
            <Countdown countdownTimer={countdownTimer} /> :
            <InfoMessage messageText={countdownInfoMessage} />}
      </main>
    </>
  );
}